<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Сутки простоя</div>
                      <router-link to="/directories/downtime-categories/new">
                        <div class="add-table-string"><i>+</i>Добавить строку</div>
                      </router-link>
                    </div>
                    <table cellpadding="0" cellspacing="0">
                      <thead>
                      <tr>
                        <td>Наименование категории</td>
                        <td>Стоимость суток (Казань), руб.</td>
                        <td>Стоимость суток (Другой город), руб.</td>
                        <td>Зар. плата (Казань), руб.</td>
                        <td>Зар. плата (Другой город), руб.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Изменить" v-for="category in downtimeCategories" @value="category"
                          @key="category.id" @click="openDowntimeCategory(category.id)" v-if="!category.removed">
                        <td class="name"> {{ category.name }}</td>
                        <td>{{ category.priceKzn }}</td>
                        <td>{{ category.price }}</td>
                        <td>{{ category.salaryKzn }}</td>
                        <td>{{ category.salary }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'DowntimeCategories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      downtimeCategories: []
    }
  },

  mounted () {
    api
      .getDowntimeCategories()
      .then(downtimeCategories => {
        if (downtimeCategories) {
          this.downtimeCategories = []
          this.downtimeCategories = downtimeCategories
        }
      })

    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    openDowntimeCategory (id) {
      this.$router.push({ name: 'DowntimeCategory', params: { id: id } })
    }
  }
}
</script>
